import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../helpers';
// ui
import { Box, Flex } from '../../ui';
//////////////////////////////////////////////////

// picker default colors
const pickerColorGrey = G.getTheme('colors.#EDEFF1');
const pickerColorRed = G.getTheme('colors.#E15141');
const pickerColorBlue = G.getTheme('colors.#4896EB');
const pickerColorGreen = G.getTheme('colors.#67AC5B');
const pickerColorYellow = G.getTheme('colors.#F4C344');

const defaultColors = [
  pickerColorGrey,
  pickerColorRed,
  pickerColorBlue,
  pickerColorGreen,
  pickerColorYellow,
];

const ColorPicker = (props) => {
  const {
    value,
    colors,
    fieldName,
    itemStyles,
    closePopper,
    activeBorder,
    setFieldValue,
    wrapperStyles,
    changeColorCallback,
    shouldTransformActive,
    shouldClosePopperOnSelect,
  } = props;

  const onChangeColor = (color, value) => {
    const valueToUse = G.ifElse(R.equals(color, value), null, color);

    G.callFunctionWithArgs(changeColorCallback, valueToUse);

    G.callFunctionWith2Args(setFieldValue, fieldName, valueToUse);

    if (G.isTrue(shouldClosePopperOnSelect)) G.callFunction(closePopper);
  };

  const _itemStyles = R.mergeRight(
    {
      width: 36,
      height: 36,
      borderRadius: '8px',
    },
    itemStyles,
  );

  const getBorder = (item, activeBorder) => {
    if (G.notEquals(item, value)) return null;

    if (G.isNotNilAndNotEmpty(activeBorder)) return activeBorder;

    return `2px solid ${G.getTheme('colors.#2B5293')}`;
  };

  return (
    <Flex {...wrapperStyles}>
      {
        R.or(colors, defaultColors).map((item, index) => (
          <Box
            key={`${index}${item}`}
            {..._itemStyles}
            title={item}
            cursor='pointer'
            background={item}
            active={R.equals(item, value)}
            border={getBorder(item, activeBorder)}
            onClick={() => onChangeColor(item, value)}
            transition={G.ifElse(shouldTransformActive, 'transform .2s linear', null)}
            transform={G.ifElse(R.and(shouldTransformActive, R.equals(item, value)), 'scale(1.25)', null)}
          />
        ))
      }
    </Flex>
  );
};

ColorPicker.defaultProps = {
  colors: defaultColors,
  itemStyles: {},
  wrapperStyles: {
    justifyContent: 'space-between',
  },
};

export {
  pickerColorRed,
  pickerColorGrey,
  pickerColorBlue,
  pickerColorGreen,
  pickerColorYellow,
  defaultColors as colors,
};

export default ColorPicker;
